export type PlatformContext = 'telegram' | 'max' | 'browser';

interface PlatformAdapter {
  readonly context: PlatformContext;
  ready(): void;
  expand(): void;
  enableClosingConfirmation(): void;
  getInitData(): string;
  getInitDataUnsafe(): unknown;
  close(): void;
}

export function detectContext(): PlatformContext {
  return window.__PLATFORM__;
}

const browserAdapter: PlatformAdapter = {
  context: 'browser',
  ready: () => { },
  expand: () => { },
  enableClosingConfirmation: () => { },
  getInitData: () => '',
  getInitDataUnsafe: () => null,
  close: () => window.close(),
};

function createTelegramAdapter(): PlatformAdapter {
  const tg = window.Telegram!.WebApp;
  return {
    context: 'telegram',
    ready: () => {
      tg.ready();
      tg.enableClosingConfirmation();
    },
    expand: () => tg.expand(),
    enableClosingConfirmation: () => tg.enableClosingConfirmation(),
    getInitData: () => tg.initData,
    getInitDataUnsafe: () => tg.initDataUnsafe,
    close: () => tg.close(),
  };
}

function createMaxAdapter(): PlatformAdapter {
  const max = window.WebApp!;
  return {
    context: 'max',
    ready: () => {
      max.ready?.();
      max.enableClosingConfirmation?.();
    },
    expand: () => max.expand?.(),
    enableClosingConfirmation: () => max.enableClosingConfirmation?.(),
    getInitData: () => max.initData ?? '',
    getInitDataUnsafe: () => max.initDataUnsafe ?? null,
    close: () => max.close?.(),
  };
}

function createAdapter(): PlatformAdapter {
  switch (detectContext()) {
    case 'telegram':
      return createTelegramAdapter();
    case 'max':
      return createMaxAdapter();
    default:
      return browserAdapter;
  }
}

const platform: PlatformAdapter = createAdapter();

export default platform